module.exports = __webpack_public_path__ + "static/image/service/pc/mart@3x.jpg?fd7884c6";